export const cognitoConfig = {
  // AWS Cognito User Pool information
  userPoolId: process.env.COGNITO_SSO_USER_POOL_ID,           // e.g., 'us-east-1_AbCdEfGhI'
  clientId: process.env.COGNITO_SSO_CLIENT_ID,                // e.g., '1abc2defghij3klmno4pqr5st'
  clientSecret: process.env.COGNITO_SSO_CLIENT_SECRET,
  region: process.env.AWS_REGION,                     // e.g., 'us-east-1'
  
  // OAuth2 settings
  oauth: {
    domain: process.env.COGNITO_DOMAIN,
    
    // OAuth scopes to request
    scope: ['email', 'openid', 'phone'],
    
    // Redirect URLs (must match those configured in your Cognito App Client settings)
    redirectSignIn: process.env.COGNITO_SSO_CALLBACK,
    redirectSignOut: process.env.COGNITO_SSO_SIGNOUT,
    
    // Using authorization code grant flow
    responseType: 'code',
    
    // Add clientId here as well for easier access in the auth service
    get clientId() {
      return cognitoConfig.clientId;
    },
    get clientSecret() {
      return cognitoConfig.clientSecret;
    }
  }
};